import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from "react";
import { useStyles } from "./LoginList.styles";
export const LoginList = () => {
    const classes = useStyles();
    return (React.createElement(Box, { component: 'section', sx: classes.root },
        React.createElement(Typography, { variant: "h1", sx: classes.title }, "Logga in"),
        React.createElement(Typography, null, "Genom att logga in p\u00E5 Mina sidor f\u00E5r du en \u00F6verblick och hanterar ditt lagerutrymme hos oss. H\u00E4r sk\u00F6ter du allt, helt enkelt."),
        React.createElement(Box, { component: 'ul', sx: classes.list },
            React.createElement("li", null, "L\u00E5sa upp utrymme"),
            React.createElement("li", null, "L\u00E4gg till tillbeh\u00F6r"),
            React.createElement("li", null, "Sl\u00E5 p\u00E5 tempertur"),
            React.createElement("li", null, "Hantera anv\u00E4ndare som har tillg\u00E5ng till utrymmet"),
            React.createElement("li", null, "Se elf\u00F6rbrukning"),
            React.createElement("li", null, "Med mera"))));
};
export default LoginList;
